<template>
	<div>
		<Modal v-model="modal.ifShow" :title="modal.Title" width="50%" :mask-closable="false" :closable="false">
			<!--控件添加修改-->

				<Form :rules="ruleInline" label-position="left"
				v-if="modal.type=='add'||modal.type=='up'||modal.type=='view'" ref="refForm" :model="modalInfo"
				:label-width="90">
				<Row v-show='false' :gutter="24" style="margin-bottom: 10px;">
					<Col span=6>
					<FormItem label="Id" prop="Id">
						<Input :disabled="modal.canInput" v-model="modalInfo.Id" placeholder="Id"></Input>
					</FormItem>
					</Col>


				</Row>
				
				<Row :gutter="24">
					<Col span=12>
					<FormItem label="救援点" prop="Name">
						<Input :disabled="modal.canInput" v-model="modalInfo.Name" placeholder="救援点"></Input>
					</FormItem>
					</Col>
				 <Col span=12>
					<FormItem label="联系人" prop="Contacter">
						<Input :disabled="modal.canInput" v-model="modalInfo.Contacter" placeholder="联系人"></Input>
					</FormItem>
					</Col>
				</Row>

				<Row :gutter="24">
					
					<Col span=12>
					<FormItem label="联系电话" prop="PhoneNo">
						<Input :disabled="modal.canInput" v-model="modalInfo.PhoneNo" placeholder="联系电话"></Input>
					</FormItem>
					</Col>
					<Col span=12>
					<FormItem label="联系地址" prop="Address">
						<Input :disabled="modal.canInput" v-model="modalInfo.Address" placeholder="联系地址"></Input>
					</FormItem>
					</Col>
				</Row>


				<Row :gutter="24">
					<Col :span="8">
					<FormItem label="经度" prop="Longitude">
						<Input  v-model.number="modalInfo.Longitude" placeholder="输入经度"></Input>
					</FormItem>
					</Col>
					<Col :span="4">
				
					</Col>

					<Col :span="8">
					<FormItem label="纬度" prop="Latitude">
						<Input  v-model.number="modalInfo.Latitude" placeholder="输入纬度"></Input>
					</FormItem>
					</Col>
					<Col :span="4">
					<FormItem :label-width="0">
						<Button  type="warning" size="small" @click="mapOpen">地图选点</Button>
					</FormItem>
					</Col>

					
				</Row>

				 <Row :gutter="24" style="margin-bottom: 10px;">
					

					

						<Col span=8>
					<FormItem label="状态" prop="Status">
						<Select :disabled="modal.canInput" placeholder="套餐状态" v-model="modalInfo.Status">
							<Option :value='0'>未生效</Option>
							<Option :value='1'>生效</Option>

						</Select>
					</FormItem>
					</Col>

				</Row>

				<!-- <Row :gutter="15">
					
				</Row> -->

			</Form>

		
			<div v-if="modal.type=='add'" slot="footer">
				<Button type="warning" size="large" @click="modalOk('cancle')">{{ $t('Common.Cancel') }}</Button>
				<Button type="success" size="large" @click="modalOk('add')">{{ $t('Common.Add') }}</Button>
			</div>
			<div v-if="modal.type=='up'" slot="footer">
				<Button type="warning" @click="modalOk('cancle')" size="large">{{ $t('Common.Cancel') }}</Button>
				<Button type="success" @click="modalOk('up')" size="large">{{ $t('Common.Edit') }}</Button>
			</div>
		</Modal>


		 <Modal :z-index="zindex" :mask-closable="false" v-model="showMap" :title="modal.Title" @on-ok="closeMap(true)"
			@on-cancel="closeMap(false)" width="70%">
			<div class="map-input">
				<Input class="lnglat" v-model="mapLng" disabled placeholder="经度" />
				<Input class="lnglat" v-model="mapLat" disabled placeholder="纬度" />
				<Input class="search" search enter-button="查找" v-model="inputCity" @on-search="searchCity"
					placeholder="输入选择城市" />
			</div>
			<div id="map" style="width: 100%;height: 500px;margin-top: 5px;">
			</div>

		</Modal>

	</div>
</template>

<script>
  import MapObj from '@/js/TMap.js';

	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../../webapi.js';
	
	export default {
		data() {
			
			return {
				modal: {
					Title: "事件添加",
					type: "add",
					ifShow: false,
					canInput: false
				},
				mapInst: null,
				mapLng: 0,
				mapLat: 0,
	            //地图modal
				center: [114.198595, 22.633595],
				showMap: false,
				inputCity: '深圳',

				
				modalInfo: {
					"Id": 0,
					"Contacter": "",
					"PhoneNo": "",
					"Address": "",
					"longitude": 0,
					"latitude": 0,
				},
				zindex: 2000,
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				imgName: '',
				visible: false,
				/****************/
				// Validate Fields
				ruleInline: {
					// Name: [{
					// 	validator: validateOpId,
					// 	trigger: 'blur',
					// }],
					RoleName: [{
						required: true,
						message: '控件名称',
						trigger: 'blur'
					}],
					RoleDesc: [{
						required: true,
						message: '显示名称',
						trigger: 'blur'
					}],
				},
			};
		},
		methods: {
			
			show: function(type, params) {
				const _this = this;
				if (type == "add") {
					_this.modal.Title = "添加";
					_this.modal.type = "add";
					_this.$refs.refForm.resetFields()
					_this.modalInfo.Id = 0
				} else if (type == "up") {
					_this.modal.Title = "修改";
					_this.modal.type = "up";
					console.log(params)
					_this.modalInfo = {...params}
					/*_this.modalInfo = {
						Id: params.Id,
						RoleName: params.RoleName,
						RoleDesc: params.RoleDesc,
						OperatorId: params.OperatorId
					};*/
				}
				_this.modal.ifShow = true
			},
			
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal.ifShow = false
						break;
					case 'add':
						_this.modal.ifShow = true
						_this.addAndUp('add');
						break;
					case 'up':
						_this.modal.ifShow = true
						_this.addAndUp('up');
						break;
					default:
						break;
				}
			},
		
			addAndUp: function(type) {
				const _this = this;
				_this.$refs.refForm.validate((valid) => {
					console.log("联系人 " + type + "----" + valid)
					if (valid) {
						let parms = _this.modalInfo
						_this.$axios.post(webapi.base_api_url + "/Archives/AddBsEmergencyContact", parms, {}).then(res => {
							console.log("新增")
							console.log(res.data)
							if (res.data.Code == 0) {
								this.$Message.success(this.$t('Common.AddSuccess'));
								_this.$emit('handleSubmit');
								_this.modalOk("cancle")
							} else {
								this.$Message.error(res.data.Msg + "---" + res.data.Data);
							}
						})
					}
				})
			},

			//地图modal
			mapOpen: function() {
				const _this = this;
				this.showMap = true;
				let latlng = [this.modalInfo.Longitude, this.modalInfo.Latitude];
				if (!this.modalInfo.Longitude || !this.modalInfo.Latitude) latlng = this.center;
				this.mapLng = this.modalInfo.Longitude;
				this.mapLat = this.modalInfo.Latitude;

				this.$nextTick(() => {
					// gaodeMap.initMap("map", 9, this.center, 'normal');
					// gaodeMap.mapOn2(this);
					// gaodeMap.createMarke(latlng)
					// if (this.StationForm.Latitude != 0) {
					// 	gaodeMap.map.setCenter(latlng)
					// }
					_this.mapInst = new MapObj(window.TMap);
					_this.mapInst.initMap('map', 10, latlng[0], latlng[1]);
					const markerId = 1;
					_this.mapInst.createMarker(markerId, latlng[0], latlng[1]);
					_this.mapInst.on('click', (evt) => {
						_this.mapInst.setMarkerPosition(markerId, evt.latLng.lng, evt.latLng.lat);
						this.mapLng = evt.latLng.lng;
						this.mapLat = evt.latLng.lat;
					})
				})
			},
			closeMap: function(result) {
				const _this = this;
				if (result) {
					this.modalInfo.Longitude = this.mapLng;
					this.modalInfo.Latitude = this.mapLat;
				}
				// gaodeMap.map.destroy();
				// gaodeMap.map = '';
				_this.mapInst.destroyMap();
				this.showMap = false;
			},
			searchCity: function() {
				const _this = this
				// _this.$axios.get('https://apis.map.qq.com/ws/geocoder/v1/?address=%E6%B7%B1%E5%9C%B3%E5%8C%97%E7%AB%99&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77')
				this.mapInst.geoCoder(_this.inputCity).then(res => {
					_this.modalInfo.Longitude = res.result.location.lng;
					_this.modalInfo.Latitude = res.result.location.lat;
					_this.mapInst.setCenter(_this.modalInfo.Longitude, _this.modalInfo.Latitude);
					_this.mapInst.setMarkerPosition(1, _this.modalInfo.Longitude, _this.modalInfo.Latitude);
				});
				// gaodeMap.geoCode(_this.inputCity).then(res => {
				// 	_this.StationForm.Latitude = res.getLat()
				// 	_this.StationForm.Longitude = res.getLng()
				// 	gaodeMap.mapOn2(_this)
				// 	gaodeMap.createMarke(res)
				// 	gaodeMap.map.setCenter(res)
				// 	//console.log(res)
				// })
			},

			/**********Component Method*********/
			handleView(name) {
				this.imgName = name;
				this.visible = true;
			},
			handleRemove(file) {
				console.log(file)
				const _this = this
				if (_this.PictureDelCache.indexOf(file.name) > 0) {
					console.log('Delete cache ')
				} else {
					console.log('Cache is not exist')
					_this.PictureUpCache.push(file.name)
				}
				const fileList = _this.$refs.upload.fileList;
				_this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				_this.$nextTick(() => {
					
					_this.uploadList = _this.$refs.upload.fileList
					_this.defaultList = _this.$refs.upload.fileList
				})
				_this.StationPicturesArray = _this.StationPicturesArray.filter(function(item, index,
					arr) {
					console.log(file.name)
					return item != file.name
				})
			},
			handleSuccess(res, file) {
				if (res.Code == 0) {
					file.url = webapi.base_api_url + res.Data;
					file.name = res.Data;
					let itemLen = this.defaultList.length;
					this.$set(this.defaultList, itemLen, file);
					this.uploadList = this.defaultList
					this.StationPicturesArray.push(file.name)
					this.PictureDelCache.push(file.name)
				}
				//file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
				//file.name = '7eb99afb9d5f317c912f08b5212fd69a';
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: this.$t('Common.FormatError'),
					desc: this.$t('Common.SelectJpgOrPng')
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: this.$t('Common.ImageTooLarge'),
					desc: this.$t('Common.File') + file.name + ' '+this.$t('Common.SelectSmallerImg')
				});
			},
			handleBeforeUpload() {
				const check = this.uploadList.length < 5;
				if (!check) {
					this.$Notice.warning({
						title: 'Up to five pictures can be uploaded.'
					});
				}
				return check;
			},
			OperatorNameChange: function(a) {
				console.log(a)
		
			}
		},
		mounted() {
			this.upHeader.Authorization = "Bearer " + encodeURIComponent(localStorage.AccessToken);
		},
		computed: {
		},


	}
</script>

<style>
</style>
